/**
 * @generated SignedSource<<64af480c914c91db1b510fce34177ff2>>
 * @relayHash 90308ee3f23c965d3be02cc175a44ffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c4ce5797d5f0008be560a06960fc2d934a6caa4c0b65b5dabd656144a79eb196

import type { ConcreteRequest } from 'relay-runtime';
export type AnalyticsDialogAnalyticsContentQuery$variables = {
  cloudId: string;
  contentId: string;
  isPrivacyModeGateEnabled: boolean;
};
export type AnalyticsDialogAnalyticsContentQuery$data = {
  readonly privacyMode?: {
    readonly isPrivacyModeEnabled: boolean;
  } | null;
  readonly singleContent: {
    readonly id: string | null;
    readonly metadata: {
      readonly createdDate: string | null;
    };
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
};
export type AnalyticsDialogAnalyticsContentQuery = {
  response: AnalyticsDialogAnalyticsContentQuery$data;
  variables: AnalyticsDialogAnalyticsContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivacyModeGateEnabled"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "createdDate"
          }
        ]
      }
    ]
  },
  {
    "condition": "isPrivacyModeGateEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "privacyMode",
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "ConfluencePrivacyMode",
        "kind": "LinkedField",
        "name": "confluence_isPrivacyModeEnabled",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isPrivacyModeEnabled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AnalyticsDialogAnalyticsContentQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AnalyticsDialogAnalyticsContentQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "90308ee3f23c965d3be02cc175a44ffc",
    "id": "c4ce5797d5f0008be560a06960fc2d934a6caa4c0b65b5dabd656144a79eb196",
    "metadata": {},
    "name": "AnalyticsDialogAnalyticsContentQuery",
    "operationKind": "query",
    "text": "query AnalyticsDialogAnalyticsContentQuery($contentId:ID!,$cloudId:ID!,$isPrivacyModeGateEnabled:Boolean!){singleContent(id:$contentId){id,type,subType,title,metadata{createdDate}},privacyMode:confluence_isPrivacyModeEnabled(cloudId:$cloudId)@include(if:$isPrivacyModeGateEnabled){isPrivacyModeEnabled}}"
  }
};
})();

(node as any).hash = "fe1ea5ee176ed78040ab6497bb6eafa9";

export default node;
